import React, { useState } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar';
import '../globalStyle.css';
import { toast } from "react-toastify";
import axios from 'axios';


export default function AddSalah() {
    const [salahInfo, setSalahInfo] = useState([]);


    const saveSalah = async (e) => {
        e.preventDefault();
        try {
    
            const salahInserted = await axios.post(
              `https://ahlehaqserver.herokuapp.com/api/salah`,
              salahInfo
            );
    
            //if request success, will show success notification
            if (salahInserted.data.code === 200) {
              setSalahInfo({});
              toast.success("Salah added successfully!");
              e.target.reset();
            }
        } catch (error) {
          console.log(error);
          // toast.error("Internal Server Error!");
        }
      };

    return (
        <div>
        <div className="row">
           <div className="col-md-3">
               <Sidebar/>
           </div>
           <div className="col-md-9">
             <h1 className="ml-3">Add Salah</h1>
              
             <form onSubmit={saveSalah}>
                      <div className="row">
                        

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Salah Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="write salah title"
                              id="exampleInputPassword1"
                              name="title"
                              value={salahInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setSalahInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Write Pdf Url<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="https://something.pdfUrl"
                              id="exampleInputPassword1"
                              name="pdfUrl"
                              value={salahInfo?.pdfUrl || ""}
                              required
                              onChange={(e) =>
                                setSalahInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         {/* <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Select Pdf<span className="text-danger">*</span>
                            </label>
                            <input
                              type="file"
                              className="form-control rounded"
                              placeholder="pdf"
                              id="exampleInputPassword1"
                              name="pdfUrl"
                              value={salahInfo?.pdf || ""}
                              required
                              onChange={(e) =>
                                setSalahInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div> */}
                          
                         
                          
                         <div className="col-md-4">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                            </div>  
                         </div> 

                      </div>

                      
                    </form>
           </div>
        </div> 
       </div>
    )
}
